const formatTime = (timeString: string): string => {
  return new Date(timeString).toLocaleTimeString('en-US', { 
    hour: 'numeric', 
    minute: '2-digit',
    hour12: true 
  });
};

export default formatTime;